import { Navigate, useNavigate, useSearchParams } from '@solidjs/router';
import { Match, Switch } from 'solid-js';
import { Container, Page } from '@troon/ui';
import ConfirmSubscription from '../../../../components/confirm-subscription';
import type { RouteDefinition } from '@solidjs/router';

export default function ConfirmationPage() {
	const [params] = useSearchParams<{ subscriptionId?: string; productId?: string; redirectAfter?: string }>();
	const navigate = useNavigate();

	return (
		<Switch>
			<Match when={!params.subscriptionId || !params.productId}>
				<Navigate href="/membership" />
			</Match>
			<Match when>
				<Page>
					<Container size="xsmall">
						<ConfirmSubscription
							subscriptionId={params.subscriptionId!}
							productId={params.productId!}
							onContinue={params.redirectAfter ? () => navigate(params.redirectAfter!) : undefined}
							continueText={params.redirectAfter ? 'Continue' : undefined}
						/>
					</Container>
				</Page>
			</Match>
		</Switch>
	);
}

export const route = { info: { nav: { appearance: 'minimal' } } } satisfies RouteDefinition;
